import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 19.75C11.9014 19.7505 11.8038 19.7312 11.7128 19.6935C11.6218 19.6557 11.5392 19.6001 11.47 19.53L5.47 13.53C5.33752 13.3878 5.2654 13.1998 5.26882 13.0055C5.27225 12.8112 5.35096 12.6258 5.48838 12.4884C5.62579 12.351 5.81118 12.2723 6.00548 12.2688C6.19978 12.2654 6.38782 12.3375 6.53 12.47L11.25 17.19V5C11.25 4.80109 11.329 4.61032 11.4696 4.46967C11.6103 4.32902 11.8011 4.25 12 4.25C12.1989 4.25 12.3896 4.32902 12.5303 4.46967C12.671 4.61032 12.75 4.80109 12.75 5V17.19L17.47 12.47C17.6122 12.3375 17.8002 12.2654 17.9945 12.2688C18.1888 12.2723 18.3742 12.351 18.5116 12.4884C18.649 12.6258 18.7277 12.8112 18.7312 13.0055C18.7346 13.1998 18.6625 13.3878 18.53 13.53L12.53 19.53C12.4608 19.6001 12.3782 19.6557 12.2872 19.6935C12.1962 19.7312 12.0985 19.7505 12 19.75C12 19.75 12 19.75 12 19.75Z",
      fill: "#212121"
    }, null, -1)
  ])))
}
export default { render: render }